import { render, staticRenderFns } from "./NsMinimalHeaderLogo.vue?vue&type=template&id=44f90805&scoped=true&"
import script from "./NsMinimalHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeaderLogo.vue?vue&type=style&index=0&id=44f90805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f90805",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f90805')) {
      api.createRecord('44f90805', component.options)
    } else {
      api.reload('44f90805', component.options)
    }
    module.hot.accept("./NsMinimalHeaderLogo.vue?vue&type=template&id=44f90805&scoped=true&", function () {
      api.rerender('44f90805', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/MinimalHeader/NsMinimalHeaderLogo.vue"
export default component.exports